import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

function generateDistinctColors(n) {
  const colors = [];
  const goldenAngle = 137.508;
  const bands = [
    { s: 70, l: 45 },
    { s: 55, l: 60 },
    { s: 85, l: 35 },
  ];
  for (let i = 0; i < n; i++) {
    const hue = (i * goldenAngle) % 360;
    const { s, l } = bands[i % bands.length];
    colors.push(`hsl(${hue.toFixed(1)}, ${s}%, ${l}%)`);
  }
  return colors;
}

function HourlyLineChart({ title, data, companies, yFormatter, tooltipFormatter, yWidth }) {
  if (!data || data.length === 0) return null;

  const COLORS = generateDistinctColors(Math.max(companies.length, 1));

  return (
    <div className="card p-20">
      <h5 className="mb-15">{title}</h5>
      <div style={{ overflowX: "auto" }}>
      <div style={{ minWidth: 700 }}>
      <ResponsiveContainer width="100%" height={450}>
        <LineChart data={data} margin={{ top: 5, right: 20, left: 20, bottom: 40 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis
            dataKey="time"
            interval={0}
            angle={-45}
            textAnchor="end"
            tick={{ fontSize: 11 }}
          />
          <YAxis width={yWidth || 80} tickFormatter={yFormatter} />
          <Legend wrapperStyle={{ paddingTop: 20 }} />
          <Tooltip
            formatter={tooltipFormatter}
            contentStyle={{
              backgroundColor: "#fff",
              border: "1px solid #e0e0e0",
              borderRadius: "6px",
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
            labelStyle={{ fontWeight: "600", marginBottom: "4px" }}
            wrapperStyle={{ zIndex: 1000 }}
          />
          {companies.map((company, index) => (
            <Line
              key={company}
              type="monotone"
              dataKey={company}
              name={company}
              stroke={COLORS[index]}
              dot={false}
              activeDot={{ r: 5 }}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
      </div>
      </div>
    </div>
  );
}

export default HourlyLineChart;
